module.exports = __webpack_public_path__ + "img/ayuda-menu.607ff375.svg";